/* tslint:disable */
/* eslint-disable */
/**
 * Walnut Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.142.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SettingsSchemaAxeAccountFromJSON, SettingsSchemaAxeAccountToJSON, } from './SettingsSchemaAxeAccount';
import { SettingsSchemaAxeDevtoolsProFromJSON, SettingsSchemaAxeDevtoolsProToJSON, } from './SettingsSchemaAxeDevtoolsPro';
import { SettingsSchemaAxeDevtoolsWatcherFromJSON, SettingsSchemaAxeDevtoolsWatcherToJSON, } from './SettingsSchemaAxeDevtoolsWatcher';
import { SettingsSchemaGeneralFromJSON, SettingsSchemaGeneralToJSON, } from './SettingsSchemaGeneral';
/**
 * Check if a given object implements the SettingsSchema interface.
 */
export function instanceOfSettingsSchema(value) {
    let isInstance = true;
    return isInstance;
}
export function SettingsSchemaFromJSON(json) {
    return SettingsSchemaFromJSONTyped(json, false);
}
export function SettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'user_id') ? undefined : json['user_id'],
        'enterpriseId': !exists(json, 'enterprise_id') ? undefined : json['enterprise_id'],
        'general': !exists(json, 'general') ? undefined : SettingsSchemaGeneralFromJSON(json['general']),
        'axeDevtoolsPro': !exists(json, 'axe-devtools-pro') ? undefined : SettingsSchemaAxeDevtoolsProFromJSON(json['axe-devtools-pro']),
        'axeDevtoolsWatcher': !exists(json, 'axe-devtools-watcher') ? undefined : SettingsSchemaAxeDevtoolsWatcherFromJSON(json['axe-devtools-watcher']),
        'axeAccount': !exists(json, 'axe_account') ? undefined : SettingsSchemaAxeAccountFromJSON(json['axe_account']),
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : json['updated_at'],
    };
}
export function SettingsSchemaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'user_id': value.userId,
        'enterprise_id': value.enterpriseId,
        'general': SettingsSchemaGeneralToJSON(value.general),
        'axe-devtools-pro': SettingsSchemaAxeDevtoolsProToJSON(value.axeDevtoolsPro),
        'axe-devtools-watcher': SettingsSchemaAxeDevtoolsWatcherToJSON(value.axeDevtoolsWatcher),
        'axe_account': SettingsSchemaAxeAccountToJSON(value.axeAccount),
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
    };
}
